module.exports = __webpack_public_path__ + "img/video2.0c701e18.png";